export const HOMEWORK_TYPES = [
  { value: "HOMEWORK", label: "Homework" },
  { value: "NOTICE", label: "Notice" },
  { value: "WARNING", label: "Warning" },
];

export const ASSIGNEE_TYPES = [
  { value: "CLASS", label: "Class" },
  { value: "CHILD", label: "Child" },
];

export function homeworkTypeLabel(type) {
  return HOMEWORK_TYPES.find((item) => item.value === type)?.label || type || "—";
}

export function assigneeLabel(assignee) {
  return ASSIGNEE_TYPES.find((item) => item.value === assignee)?.label || assignee || "—";
}

export function teacherName(teacher) {
  if (!teacher) return "—";
  const name = `${teacher.firstName || ""} ${teacher.lastName || ""}`.trim();
  return name || "—";
}

export function childName(child) {
  if (!child) return "—";
  const name = `${child.firstName || ""} ${child.lastName || ""}`.trim();
  return name || "—";
}

export function classroomName(classroom) {
  if (!classroom) return "—";
  return classroom.classroomName || classroom.name || classroom.className || "—";
}

export function assigneeSummary(item) {
  if (item.assignee === "CLASS") {
    return classroomName(item.classroomDoc || item.classroom);
  }
  return childName(item.childDoc || item.children);
}

export function typeBadgeClass(type) {
  if (type === "WARNING") return "is-inactive";
  if (type === "NOTICE") return "is-pending";
  return "is-active";
}

export function snippet(text = "", max = 80) {
  const value = String(text || "").trim();
  if (!value) return "—";
  return value.length > max ? `${value.slice(0, max).trim()}…` : value;
}
